import {
  VALIDATE_EMAIL,
  VALIDATE_EMAIL_SUCCEEDED,
  VALIDATE_EMAIL_CLEAR
} from "../../common/constants";

export const initialState = { email: "", status: "" };

export const validateEmailReducer = (state = initialState, action = {}) => {
  // console.log(action.singleEmail);
  // console.log(action.type);
  switch (action.type) {
    case VALIDATE_EMAIL:
      return {
        ...state,
        email: action.email,
        showLoader: true,
        status: action.status,
        username: action.username,
      };
    case VALIDATE_EMAIL_SUCCEEDED:
      return {
        ...state,
        showLoader: false,
        status: action.singleEmail.status,
        result: action.singleEmail.result.result,
      };
    case VALIDATE_EMAIL_CLEAR:
      return {
        ...state,
        showLoader: false,
        status: null,
        result: null
      }
    
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Containers/SingleEmailValidation/reducer.js